/** * @description 层级选择 */
<template>
  <div class="yl-class-select" v-click-outside="hideModal">
    <div class="cp-input" @click="focus">
      <el-input
        class="el-select el-select--small"
        :placeholder="placeholder"
        v-model="valueInput"
        :title="valueInput"
        :disabled="disabled"
        ref="caderInput"
        id="caderInput"
        :name="name"
        :validate-event="false"
      >
        <template #suffix>
          <el-icon
            v-if="clearable && !disabled && valueInput"
            @click="clearInput"
          >
            <Close />
          </el-icon>
          <el-icon v-else>
            <ArrowDown v-show="!isShow" />
            <ArrowUp v-show="isShow" />
          </el-icon>
        </template>
      </el-input>
    </div>
    <el-collapse-transition>
      <div class="cp-modal" v-show="isShow">
        <div class="cpm-ul">
          <template v-for="(tab, tabIndex) in initData">
            <div
              ref="pList"
              :key="tabIndex"
              v-if="tabIndex <= showLevel"
              @click="clickTab(tabIndex)"
              class="cpml-li"
              :class="[
                typeClass === tabIndex ? 'isActive' : '',
                tabIndex > (selectList || []).length ? 'disable' : ''
              ]"
            >
              {{ tab.name }}
            </div>
          </template>
          <div
            class="cpml-line"
            :style="
              'width:' +
              lineWidth +
              'px;' +
              'transform:translateX(' +
              lineLeftW +
              'px)'
            "
          />
        </div>
        <el-input :placeholder="$t('关键字搜索')" v-model="filterText" />
        <div class="cpm-content">
          <el-scrollbar
            ref="scrollbar"
            height="180px"
            wrap-class="base-address-cader__wrap"
          >
            <div v-for="(tab, tabIndex) in initData" :key="tabIndex">
              <div
                v-show="tabIndex === typeClass"
                class="cpmc-li"
                ref="cmpcli"
                v-for="item in dataList[tabIndex] &&
                dataList[tabIndex].length > 0 &&
                filterText
                  ? dataList[tabIndex].filter(
                      o =>
                        !filterText ||
                        o[getLabelKey(tabIndex)]
                          .toLowerCase()
                          .match(filterText.toLowerCase())
                    )
                  : dataList[tabIndex]"
                @click="selectListClick(item[getValueKey(tabIndex)])"
                :class="{
                  isSelectActive:
                    (selectList[tabIndex] || {})[getValueKey(tabIndex)] ===
                    item[getValueKey(tabIndex)]
                }"
                :key="item[getValueKey(tabIndex)]"
                :title="item[getLabelKey(tabIndex)]"
              >
                {{ item[getLabelKey(tabIndex)] }}
              </div>
              <span
                class="el-icon-loading"
                v-show="
                  tabIndex === typeClass &&
                  loadingList[tabIndex] &&
                  (!dataList[tabIndex] || !dataList[tabIndex].length)
                "
              />
              <span
                class="tip"
                v-show="
                  tabIndex === typeClass &&
                  !loadingList[tabIndex] &&
                  (!dataList[tabIndex] || !dataList[tabIndex].length)
                "
                >{{ $t('无数据') }}</span
              >
            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import { ClickOutside } from 'element-plus';
import { $t } from '@/plugins/i18n';
import { reqQueryRegionList } from '@/api/common';
export default {
  name: 'ClassSelect',
  directives: {
    // 在模板中启用 v-xxx
    ClickOutside
  },
  emits: ['update:model-value', 'change', 'changeValue'],
  data() {
    return {
      // 当前是否处于聚焦展开状态，该状态下可触发键盘事件
      isShow: false,
      onlyName: false,
      activeName: 'first',
      lineWidth: 0,
      lineLeftW: 0,
      dataList: [], //  待选下拉数据，二维数组，格式[[],[]]
      dataListMap: {}, //  缓存的下拉待选数据,格式父级id+层级: []
      //  请求loading
      loadingList: [],
      cacheAreaMap: {},
      typeClass: 0,
      //  当前选中数据
      selectList: [],
      oldSelectList: [],
      name: '',
      valueInput: '',
      filterText: '',
      suffixIcon: 'el-icon-arrow-down',
      rootParentValue: 0
    };
  },
  props: {
    type: {
      type: String,
      default: 'search'
    },
    modelValue: {
      type: Array,
      default: () => null
    },
    // 最大展示层级,从0开始 eg：1-国家；2-大区；3-省；4-市；5-区
    showLevel: {
      default: 2
    },
    isShowZipCode: {
      // 是否显示区域code
      type: Boolean,
      default: false
    },
    showZipCodeIndex: {
      // 区域所在索引位置
      type: Number,
      default: 2
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Array,
      default: () => [
        {
          name: $t('大区'),
          label: 'areaName',
          value: 'areaCode'
        },
        {
          name: $t('省'),
          label: 'areaName',
          value: 'areaCode'
        },
        {
          name: $t('市'),
          label: 'areaName',
          value: 'areaCode'
        }
      ]
    }
  },
  computed: {
    placeholder() {
      const tab = this.initData[this.showLevel] || {};
      // return `${this.$t('请选择' + (tab.name || ''))}`;
      return this.$t('请选择') + (tab.name || '');
    },
    valueKey() {
      return this.initData[this.typeClass]?.value;
    }
  },
  watch: {
    disabled(newVal) {
      if (newVal) {
        this.isShow = false;
      }
    },
    showLevel() {
      this.clearInput();
    },
    typeClass(newVal) {
      if (!newVal && newVal !== 0) {
        this.typeClass = this.typeClass || 0;
      }
      if (!this.$refs.pList[this.typeClass]) {
        return;
      }
      if (this.typeClass === 0) {
        const { clientWidth } = this.$refs.pList[this.typeClass];
        this.lineLeftW = 0;
        this.lineWidth = clientWidth || 0;
      } else {
        const { clientWidth } = this.$refs.pList[this.typeClass];
        this.lineLeftW =
          this.$refs.pList[this.typeClass].getBoundingClientRect().x -
          this.$refs.pList[0].getBoundingClientRect().x;
        this.lineWidth = clientWidth;
      }
    },
    modelValue: {
      handler(newVal) {
        console.log('modelValuemodelValuemodelValue', newVal);
        if (newVal && newVal.length) {
          const parentValueKey = this.initData[0]?.value;
          if (!parentValueKey) {
            console.error('请正确配置initData');
          }
          this.onlyName = !newVal.every(
            item => item[parentValueKey || 'areaCode'] !== undefined
          );
          const parent = {};
          parent[parentValueKey || 'areaCode'] = this.rootParentValue;
          //  如果不相等
          if (!this.isEqual(newVal, this.selectList)) {
            this.selectList = [...newVal];
            this.getDataList(parent);
          } else if (
            !this.dataList ||
            !this.dataList.length ||
            this.dataList.length !== newVal.length
          ) {
            this.getDataList(parent);
          }
        } else if (!this.isEqual(newVal, this.selectList)) {
          this.clearInput();
        }
      },
      deep: true, //  深入监听
      immediate: true //  绑定时执行
    }
  },
  created() {
    // console.log('ClassSelect created');
  },
  mounted() {
    // console.log('ClassSelect mounted');
  },
  methods: {
    getValueKey(typeClass) {
      return this.initData[typeClass]?.value;
    },
    getLabelKey(typeClass) {
      return this.initData[typeClass]?.label;
    },
    /**
     * 是否相等
     */
    isEqual(selectList, oldSelectList) {
      if (selectList === oldSelectList) {
        return true;
      }
      if ((!selectList && oldSelectList) || (selectList && !oldSelectList)) {
        return false;
      }
      if (selectList.length === oldSelectList.length) {
        for (const key in selectList) {
          const selectData = selectList[key];
          const oldData = oldSelectList[key];
          const valueKey = this.initData[key].value;
          if (selectData[valueKey] !== oldData[valueKey]) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
    scrollToActive() {
      this.$nextTick(() => {
        this.$refs.scrollbar.handleScroll();
      });
    },
    // 关闭
    hideModal() {
      if (this.isShow) {
        this.isShow = false;
        const typeClass = this.selectList?.length || 1;
        this.clickTab(typeClass - 1);
      }
    },
    // 展开
    focus() {
      if (this.disabled) {
        return;
      }
      if (!this.isShow) {
        this.isShow = true;
        let typeClass = this.selectList?.length || 1;
        console.log();
        typeClass = --typeClass;
        console.log(565655656, typeClass);
        const rev = () => {
          setTimeout(() => {
            console.log(this.$refs.pList);
            const { clientWidth } = this.$refs.pList[typeClass];
            if (clientWidth) {
              this.clickTab(typeClass);
            } else {
              rev();
            }
          }, 10);
        };
        rev();
        // 只有name 没有id 触发弹窗清一下
        if (this.onlyName) {
          this.onlyName = false;
          this.$emit('update:model-value', []);
          this.$emit('change', [], this.oldSelectList);
          this.$emit('changeValue', []);
        }
      }
    },
    // 点击tab,切换层级
    clickTab(typeClass) {
      if (
        typeClass > (this.selectList || []).length ||
        typeClass > this.showLevel
      ) {
        return;
      }
      if (this.loadingList.find(loading => loading)) {
        // this.$message.info(this.$t('请求中，请稍后'))
        return;
      }
      if (!this.$refs.pList || !this.$refs.pList[typeClass]) {
        return;
      }
      // 切换层级时清除输入的过滤条件
      this.valueInput = this.getValueInput();
      this.filterText = '';
      this.typeClass = typeClass;
      // 如果本层级没有待选数据，则发起请求
      if (!this.dataList[typeClass] || !this.dataList[typeClass].length) {
        const parent = this.selectList[typeClass - 1] || {};
        console.log('parent', parent);
        if (!typeClass) {
          const parentValueKey = this.initData[0]?.value;
          console.log('parentValueKey', parentValueKey);
          parent[parentValueKey || 'areaCode'] = this.rootParentValue; // 没有父级，则默认父级key为0
        }
        console.log('getDataList', parent, typeClass);
        this.getDataList(parent, typeClass);
      }
      this.scrollToActive();
    },
    /**
     * 获取待选数据
     * @parent 父级数据
     * @typeClass 当前要获取的待选列表所在层级
     */
    async getDataList(parent, typeClass = 0) {
      if (this.loadingList.find(loading => loading)) {
        return;
      }
      const valueKey = this.initData[typeClass]?.value;
      const childValueKey = this.initData[typeClass + 1]?.value;
      const fillBackProvince = () => {
        this.loadingList[typeClass] = false;
        const selectData = this.selectList[typeClass] || {};
        //  如果有选中
        if (selectData[valueKey]) {
          //  同步已选中数据
          const obj = this.dataList[typeClass].find(
            item => item[valueKey] === selectData[valueKey]
          );
          if (obj) {
            this.selectList[typeClass] = obj;
          }
          // showLevel按理应取initData的长度，为了兼容旧的showLevel配置，这里只做提醒
          if (this.showLevel > typeClass && !childValueKey) {
            console.error(
              'initData 与 showLevel 层级不匹配，注意showLevel是从下标0开始算'
            );
          }
          if (
            this.showLevel > typeClass &&
            childValueKey &&
            (this.selectList[typeClass + 1] || {})[childValueKey]
          ) {
            this.getDataList(selectData, ++typeClass);
          } else {
            //  没有下级选中，则触发数据同步处理
            this.updataValue();
          }
        } else if (this.selectList.length > 0) {
          // 没有id 直接回显name
          let valueInput = '';
          console.log('selectList', this.selectList);
          this.selectList.forEach(item => {
            valueInput = item.areaName
              ? `${valueInput}/${item.areaName}`
              : valueInput;
          });
        }
      };
      if (typeClass > this.showLevel) {
        return;
      }
      this.selectList = this.selectList || [];
      const parentTypeClass = typeClass ? typeClass - 1 : 0;
      const parentValueKey = this.initData[parentTypeClass]?.value;
      const parentId = parent[parentValueKey];
      const dataLishCatch = this.dataListMap[`${parentId}${typeClass}`];
      //  取缓存
      if (dataLishCatch && dataLishCatch.length) {
        this.dataList[typeClass] = dataLishCatch;
        fillBackProvince();
        return;
      }
      //  请求获取
      try {
        this.loadingList[typeClass] = true;
        // const resData = await this.reqList(parent, typeClass, this.selectList);
        const params = {
          parentCode: parent.areaCode ? parent.areaCode : ''
        };
        const resData = await reqQueryRegionList(params);
        this.loadingList[typeClass] = false;
        if (resData === undefined) {
          this.dataList[typeClass] = [];
          this.dataListMap[`${parentId}${typeClass}`] = [];
          return;
        }
        if (!resData.code && resData.code !== 0) {
          this.dataList[typeClass] = [];
          this.dataListMap[`${parentId}${typeClass}`] = [];
          this.$message.error(this.$t('请求异常，请联系客服'));
          return;
        }
        if (resData.code !== 1) {
          this.dataList[typeClass] = [];
          this.dataListMap[`${parentId}${typeClass}`] = [];
          this.$message.error(resData.msg);
          return;
        }
        if (!resData.data) {
          this.dataList[typeClass] = [];
          this.dataListMap[`${parentId}${typeClass}`] = [];
          return;
        }
        this.dataList[typeClass] = resData.data.records || resData.data;
        this.dataListMap[`${parentId}${typeClass}`] =
          resData.data.records || resData.data;
        fillBackProvince();
      } catch (e) {
        console.error(e);
        // this.$message.error(this.$t('请求异常，请联系客服'));
        this.dataList[typeClass] = [];
        this.loadingList[typeClass] = false;
      }
    },
    // 视图手动选中
    selectListClick(key) {
      console.log('selectListClick', key);
      const obj = this.dataList[this.typeClass].find(
        item => item[this.valueKey] === key
      );
      if (
        this.selectList &&
        this.selectList[this.typeClass] &&
        obj[this.valueKey] === this.selectList[this.typeClass][this.valueKey]
      ) {
        this.clickTab(this.typeClass + 1);
        return;
      }
      this.selectList.splice(
        this.typeClass,
        this.selectList.length - this.typeClass,
        obj
      );
      this.updataValue();
      const showLevel = parseInt(this.showLevel);
      if (showLevel === this.typeClass + 1) {
        this.hideModal();
      } else if (showLevel > this.typeClass) {
        this.dataList.splice(++this.typeClass);
        this.clickTab(this.typeClass);
      }
    },
    getValueInput() {
      let valueInput = '';
      for (const key in this.selectList) {
        const obj = this.selectList[key];
        const valueKey = this.initData[key].value;
        const labelKey = this.initData[key].label;
        //  异常数据直接中断
        if (!obj || !obj[valueKey]) {
          break;
        }
        if (key === `${this.showLevel}`) {
          valueInput += obj[labelKey] || '-- --';
          break;
        } else {
          valueInput += `${obj[labelKey] || '-- --'}/`;
        }
      }
      if (this.selectList.length === 3) {
        valueInput = valueInput.slice(0, -1);
      }
      return valueInput;
    },
    // 传递选中的值到父组件
    updataValue() {
      //  相等则不更新
      if (this.isEqual(this.selectList, this.oldSelectList)) {
        return;
      }
      this.valueInput = this.getValueInput();
      this.oldSelectList = [...this.selectList];
      const data = [...this.selectList];
      this.$parent.clearValidate && this.$parent.clearValidate();
      this.$emit('update:model-value', data);
      this.$emit('change', data, this.oldSelectList);
      this.$emit('changeValue', data);
      this.$nextTick(_ => {
        this.$refs.caderInput && this.$refs.caderInput.focus();
      });
    },
    // 清空选中
    clearInput() {
      // console.log('reqList clearInput');
      this.defaultDataLen = false;
      this.valueInput = '';
      this.filterText = '';
      this.typeClass = 0;
      this.dataList = [];
      this.selectList = [];
      this.clickTab(0);
      this.updataValue();
    },
    /**
     * 重置整个下拉框
     */
    resetInput(rootParentValue = 0) {
      // console.log('reqList resetInput', rootParentValue);
      // this.dataListMap = [];
      this.rootParentValue = rootParentValue;
      this.clearInput();
    }
  }
};
</script>
<style lang="scss">
.yl-class-select {
  $selectH: 360px;
  width: 100%;
  .cp-input {
    .el-icon-circle-close {
      display: none;
      position: absolute;
      top: 10px;
      right: 6px;
      color: var(--el-color-primary);
    }
    &:hover {
      .el-icon-circle-close {
        display: inline;
      }
    }
    .el-input__wrapper {
      width: 100%;
    }
  }
  .el-form-item.is-error {
    .cp-input {
      .el-icon-circle-close {
        display: none;
      }
      &:hover {
        .el-icon-circle-close {
          display: none;
        }
      }
    }
  }
  position: relative;
  .el-icon-loading {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 50px;
    margin-left: -10px;
    font-size: 20px;
  }
  .el-select__caret {
    transform: rotateZ(180deg);
    transition: transform 0.1s;
    cursor: pointer;
  }
  span,
  .el-input__suffix {
    cursor: pointer;
    .el-icon-circle-close {
      color: var(--el-color-primary);
    }
  }
  .el-scrollbar__wrap {
    overflow: auto;
    // max-height: $selectH;
    height: $selectH;
    min-width: 200px;
  }
  div {
    box-sizing: border-box;
  }
  .disable {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
  .cp-modal {
    position: absolute;
    background-color: #ffffff;
    width: 100%;
    // height: $selectH;
    z-index: 9999;
    top: 37px;
    border-radius: 4px;
    border: 1px solid var(--el-border-color);
    box-shadow: 0 0 10px #88888851;
    .cpm-ul {
      display: flex;
      height: 28px;
      align-items: center;
      border-bottom: 1px solid var(--el-border-color);
      padding: 0px;
      position: relative;
      justify-content: space-around;
      flex-wrap: nowrap;
      .isActive {
        color: var(--el-color-primary);
        font-weight: bolder;
      }
      .cpml-line {
        width: 50px;
        height: 2px;
        transform: rotateZ(180deg);
        transition: transform 0.3s;
        // @include text-color();
        // @include base-color('bg');
        position: absolute;
        bottom: -1px;
        left: 0;
      }
      .cpml-li {
        cursor: pointer;
        margin: 0px;
        color: var(--el-color-primary);
        font-size: 14px;
        flex-grow: 1;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .cpm-content {
      .el-scrollbar {
        min-height: 50px;
        .base-address-cader__wrap {
          // padding-top: 5px;
          .cpmc-li {
            width: 100%;
            padding: 0px 0px 0px 5px;
            // @include text-color();
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &:last-child {
              margin-bottom: 12px;
            }
            &:hover {
              // @include bg-color('pop-active');
              color: var(--el-color-primary);
            }
          }
          .tip {
            width: 100%;
            text-align: center;
            color: var(--el-color-primary);
            display: block;
            margin-top: 20px;
          }
          .isSelectActive {
            // @include bg-color('pop-active');
            color: var(--el-color-primary);
          }
          margin-bottom: 0 !important;
        }
      }
    }
  }
}
</style>
